<template>
  <div id="app" class="main">
    <topImg
      img="https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/bb0cc1803cb44921031291686d79c0cb.png"
    ></topImg>
    <div class="content">
      <el-tabs v-model="tabSelected" @tab-click="tabChange" class="tab">
        <el-tab-pane label="产品介绍"></el-tab-pane>
        <el-tab-pane label="招商合作"></el-tab-pane>
      </el-tabs>
      <div class="teacher" v-if="tabSelected == 0">
        <!-- 格灵元 -->
        <div class="module gly">
          <div>
            <div class="introduce">
              <img
                v-lazy="'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/ec61ba95068c3facf9a183333978bece.png'"
                alt=""
              />
              <div class="right">
                <div class="title">产品介绍</div>
                <div class="desc">
                  国内率先提供元宇宙教育一体化解决方案平台，内容涵盖学科教育、素质教育、 心理教育、
                  爱国主义教育、理化生实验等，支持元宇宙多场景应用，资源、管理、创作、远程教育等。
                  虚拟与现实全面交织、人与机器全面协同、学校与社会全面连接的元宇宙教育平台。
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 中小学元宇宙教育建设架构 -->
        <div class="module Metaverse">
          <div>
            <div class="headline">中小学元宇宙教育建设架构</div>
            <div class="character" style="margin-top: 0">
              <div class="left">
                <div class="list">
                  <div class="title">
                    <img src="./assets/icon_changjing.png" alt="">
                    多场景应用打破时空限制
                  </div>
                  <div class="desc">
                    学校、图书馆、博物馆、少年宫、培训机构、家庭
                  </div>
                </div>
                <div class="list">
                  <div class="title">
                    <img src="./assets/icon_duopingtai.png" alt="">
                    多平台融合支撑元宇宙各场景教学
                  </div>
                  <div class="desc">
                    资源平台、管理平台、创作平台、元宇宙远程教育平台
                  </div>
                </div>
                <div class="list">
                  <div class="title">
                    <img src="./assets/icon_duozhongduan.png" alt="">
                    多终端设备支撑XR各场景应用
                  </div>
                  <div class="desc">
                    教学一体机、3DOF、6DOF、MR一 体机、 三维交互一体机、AR台
                  </div>
                </div>
                <div class="list">
                  <div class="title">
                    <img src="./assets/icon_jishu.png" alt="">
                    多技术融合
                  </div>
                  <div class="desc">
                    人工智能 、VR/AR/MR  、 区块链 、 云计算 、 数字孪生
                  </div>
                </div>
              </div>
              <div class="right">
                <img src="./assets/bj_peitu.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- 六大场景 -->
        <div class="module scenario">
          <div>
            <div class="headline">六大场景</div>
            <div class="character">
              <div class="right" style="margin-right: 20px">
                <img
                v-lazy="'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/1065518d4e934ca2f91048c050dc7ce6.png'"
                alt=""
              />
              </div>
              <div class="left">
                <div class="list">
                  <div class="title">学校</div>
                  <div class="desc">
                    VR学科通识教育、VR编程创客教育、VR爱国主题教育、VR安全教育、VR心理健康教育、元宇宙远程教育、
                    VR理化生实验主题、VR职业体验教育
                  </div>
                </div>
                <div class="list">
                  <div class="title">图书馆</div>
                  <div class="desc">
                    VR学科通识教育、VR心理健康教育、VR爱国主题教育、VR安全教育、VR职业体验教育、VR红色党建教育
                  </div>
                </div>
                <div class="list">
                  <div class="title">博物馆</div>
                  <div class="desc">
                    VR学科通识教育、VR红色党建教育
                  </div>
                </div>
                <div class="list">
                  <div class="title">少年宫、科技馆、家庭</div>
                  <div class="desc">
                    VR编程创客教育、元宇宙远程教育
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 中小学相关案例 -->
        <div class="module k12">
          <div>
            <div class="headline">中小学相关案例</div>
            <div class="content">
              <div class="three">
                <div class="list" v-for="item of k12Top" :key="item.name">
                  <img :src="item.imageurl" alt="" />
                  <span class="title">{{ item.name }}</span>
                </div>
              </div>
              <div class="two">
                <div class="list" v-for="item of k12Down" :key="item.name">
                  <img :src="item.imageurl" alt="" />
                  <span class="title">{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="manage" v-else>
        <!-- 项目优势 -->
        <div class="module proEdvantage">
          <div>
            <div class="headline">项目优势</div>
            <div class="advantage">
              <div v-for="item in advantageList" :key="item.title" >
                <div class="head">
                  <img class="icon" :src="item.icon" alt="">
                  <span>{{item.title}}</span>
                </div>
                <div class="desc" v-for="it in item.desc" :key="it.title">
                  <span>{{it.title}}</span>
                  <span>{{it.desc}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 代理商收益测算 -->
        <div class="module earnings">
          <div>
            <div class="headline">代理商收益测算</div>
            <img src="./assets/bg.png" alt="">
          </div>
        </div>
        <!-- 代理支持 - 五位支持 -->
        <div class="module support_five">
          <div>
            <div class="headline">“五位一体”服务运营</div>
            <div class="support">
              <div class="content">
                <div class="left">
                  <div class="list">
                    <span class="title">商机共享</span>
                    <div class="desc">
                      通过网络推广共享线索商机、参与行业展会，对接区域商机、参与产品推荐获取学校商机、举办大型研讨会，搭建研讨交流平台
                    </div>
                  </div>
                  <div class="list">
                    <span class="title">销售支持</span>
                    <div class="desc">
                      资深销售团队，项目全流程的销售协助与服务支持，助力项目落地
                    </div>
                  </div>
                </div>
                <img src="./assets/five_in_one.png" >
                <div class="right">
                  <div class="list">
                    <span class="title">市场拓展</span>
                    <div class="desc">
                      协助打造区域标杆，扩大品牌宣传，快速拓展业务；扶持招商，快速拓宽渠道
                    </div>
                  </div>
                  <div class="list">
                    <span class="title">团队赋能</span>
                    <div class="desc">
                      提供从招聘-培训-考核-培养等全流程支持，完善的培训体系，赋能城市合伙人团队
                    </div>
                  </div>
                </div>
                <div class="bottom">
                  <div class="list">
                    <span class="title">项目实施</span>
                    <div class="desc">
                      协助项目部署、软硬件安装、教师培训，直到客户满意并签订验收单，完成交付
                    </div>
                  </div>
                </div>
                <!-- <div class="two">
                  <div class="list" v-for="item of supportDown" :key="item.name">
                    <img :src="item.imageurl" alt="" />
                    <div class="title">{{ item.title }}</div>
                    <div>{{ item.desc }}</div>
                  </div>
                </div>
                <div class="three">
                  <div class="list" v-for="item of supportTop" :key="item.name">
                    <img :src="item.imageurl" alt="" />
                    <div class="title">{{ item.title }}</div>
                    <div>{{ item.desc }}</div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
        <!-- 代理支持 - 一体支持 -->
        <div class="module support_one">
          <div>
            <div class="headline">代理支持：一体支持</div>
            <div class="character">
              <div class="left">
                <div class="list" style="margin-top: 20px">
                  <div class="title">一体：一体化元宇宙教学解决方案支持</div>
                  <div class="desc">
                    <div>
                      <span>· 学生、教师、远程教学</span>
                      <span>· 一体化元宇宙教学解决方案</span>
                    </div>
                    <div>
                      <span>· 强大的VR产品体系</span>
                      <span>· 自研优质VR课程资源</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="right">
                <img src="./assets/peitu_zhichi.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <!-- 加盟政策 -->
        <div class="module policy">
          <div>
            <div class="headline">加盟政策</div>
            <div class="character">
              <div>
                <span>授权产品</span>
                <span>底价供货</span>
                <span>区域保护</span>
              </div>
              <div>
                <img src="https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/812293d3d510b9e3960a3d8e78b561d0.png" alt="">
              </div>
              <div>
                <span>市场限价</span>
                <span>大项目合作</span>
                <span>总部直客</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 加盟条件 -->
        <div class="module condition">
          <div>
            <div class="headline">加盟条件</div>
            <div class="character">
              <div>
                <img src="./assets/icon_chuangye.png" alt="">
                <span>创业热情</span>
              </div>
              <div>
                <img src="./assets/icon_linian.png" alt="">
                <span>理念认同</span>
              </div>
              <div>
                <img src="./assets/icon_shanyu.png" alt="">
                <span>善于沟通</span>
              </div>
              <div>
                <img src="./assets/icon_kuai.png" alt="">
                <span>快速学习</span>
              </div>
              <div>
                <img src="./assets/icon_zhixing.png" alt="">
                <span>执行力强</span>
              </div>
            </div>
          </div>
        </div>
        <!-- 加盟流程 -->
        <div class="module process">
          <div>
            <div class="headline">加盟流程</div>
            <div class="character">
              <div class="line"></div>
              <div class="content">
                <div v-for="(item, index) in processList" :key="index">
                  <div class="round"></div>
                  <div class="short_line"></div>
                  <span>{{item}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  // metaInfo: {
  //   title: '格灵元课堂-格如灵科技', // set a title
  //   meta: [ // set meta
  //     {
  //       name: 'keyWords',
  //       content: '格灵元课堂,格如灵,格如灵科技'
  //     },
  //     {
  //       name: 'description',
  //       content: '格灵元课堂提供元宇宙教育一体化解决方案平台，格灵元课堂支持元宇宙多场景应用，资源、管理、创作、远程教育等。格灵元课堂是虚拟与现实全面交织、人与机器全面协同、学校与社会全面连接的元宇宙教育平台。'
  //     }
  //   ]
  // },
  data() {
    return {
      tabSelected: 0,
      k12Top: [
        {
          imageurl: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/9eaf49e9a1f67b9f200bebe703a43f0a.png',
          name: '杭州市富阳场口镇中心小学'
        },
        {
          imageurl: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/f7fba12f1f3b7cf6c72ff6f77c4d6950.png',
          name: '河北省青龙第三实验小学'
        },
        {
          imageurl: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/7a0865c158c6071c2e51eb5c47883444.png',
          name: '江西九江市彭泽县珍珠湖小'
        }
      ],
      k12Down: [
        {
          imageurl: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/539456554f2fe8acfad3bd5a64f74be5.png',
          name: '柬埔寨'
        },
        {
          imageurl: 'https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/55ecf502734602caf7bd7c0bdaa7827d.png',
          name: '澳大利亚'
        }
      ],
      advantageList: [
        {
          icon: require('./assets/icon_shouyi@2x.png'),
          title: '高收益低风险',
          desc: [
            {
              title: '独家授权: ',
              desc: '以区、县为区域单位，可按区域设立代理，垄断区域收益。'
            },
            {
              title: '高额利润: ',
              desc: '60%以上的利润空间。'
            },
            {
              title: '续费率高: ',
              desc: '学校每年都有新的生源。'
            }
          ]
        },
        {
          icon: require('./assets/icon_shichang@2x.png'),
          title: '广阔的市场前景',
          desc: [
            {
              title: '市场规模大: ',
              desc: '2021年中国共有52.93万所学校，在校生人数达2.91亿人。2022年中国教育产业市场规模将达4万亿元。'
            }
          ]
        },
        {
          icon: require('./assets/icon_fuwu@2x.png'),
          title: '360°服务支持',
          desc: [
            {
              title: '多元培训课程: ',
              desc: '远程培训与线下培训相结合，精讲产品卖点、销售技巧、管理方法、客户分析等，涉及分中心业务的各个环节，全方位打造精英人才。'
            },
            {
              title: '专业的1对1指导: ',
              desc: '拥有丰富经验的专业区域经理，一对一贴心服务，指导代理商建立个性化营销渠道，快速占领市场。'
            },
            {
              title: '启动实训机制: ',
              desc: '全国十几家实训基地，为周边代理商提供学习场地、业务培训，分享运营经验，带动周边分中心提升业绩。'
            },
            {
              title: '全面市场扶持机制: ',
              desc: '深入学校的教研活动，国家重点课题研究，各类全国性大赛，多类型市场活动驱动产品全面落地应用。'
            }
          ]
        },
        {
          icon: require('./assets/icon_chengshu@2x.png'),
          title: '成熟的商业模式',
          desc: [
            {
              title: '模式成熟: ',
              desc: '近 100 家高额盈利代理商的成功经验与模式，全新模式简单操作且容易复制。'
            }
          ]
        },
        {
          icon: require('./assets/icon_youzhzi@2x.png'),
          title: '优质个性化产品体系',
          desc: [
            {
              title: '丰富的产品: ',
              desc: '未来课堂、智慧宫、格灵世界、红色教育满足了学校的不同应用场景需求。'
            },
            {
              title: '强大师资阵容: ',
              desc: '多位优秀名师,联手打造优质课程。'
            },
            {
              title: '优质的学习效果: ',
              desc: '沉浸式、体验式、探究式学习，激发学生的学习兴趣。'
            }
          ]
        }
      ],
      supportTop: [
        {
          imageurl: require('./assets/icon_zhichi_3@2x.png'),
          title: '销售支持',
          desc: '销售物料包：市场推广方案/项目呈报方案模板/标品参数/省代招商手册。'
        },
        {
          imageurl: require('./assets/icon_zhichi_4@2x.png'),
          title: '投放支持',
          desc: '百度网推线索支持，提供线索量，官网公示代理信息。'
        },
        {
          imageurl: require('./assets/icon_zhichi_5@2x.png'),
          title: '品牌宣传',
          desc: '合作案例公众号推广展示，优秀代理商公众号推文宣传，pr品牌内容推广各省市媒体宣传。'
        }
      ],
      supportDown: [
        {
          imageurl: require('./assets/icon_zhichi_1@2x.png'),
          title: '活动支持',
          desc: '线上活动:招商会/研讨会/启动会等；线下活动：大型招商；展会活动：协助参加地方行业展会、总部参展展会优秀代理商可参展；物料：提供动态、静态宣传物料。'
        },
        {
          imageurl: require('./assets/icon_zhichi_2@2x.png'),
          title: '课程授权',
          desc: '元宇宙教育一体化解决方案平台内容全部授权学校、经销商可自行营运平台进行元宇宙授课；总部统一进行线上元宇宙教学。'
        }
      ],
      processList: [
        '项目咨询',
        '提交《城市合伙人申请表》',
        '资质评估',
        '当面洽谈项目考核',
        '总部综合考察/通过',
        '签订合同',
        '支持项目启动'
      ]
    };
  },
  mounted() {},
  methods: {
    tabChange(tab) {
      this.tabSwlected = tab.index;
    }
  }
  //   watch: {
  //     tabSwlected(tab) {
  //       console.log('change', tab)
  //       if (tab === 0) {
  //         this.getHighList()
  //       } else {
  //         this.getK12List()
  //       }
  //     }
  //   }
};
</script>
<style lang="less" scoped>
@import '~@/assets/fonts/pingfang.css';
.main {
  background: #fff;
  .content {
    width: 100%;
    margin: 0 auto;
    .tab {
      width: 1200px;
      margin: 0 auto;
      margin-top: 60px;
    }
    .module {
      > div {
        width: 1200px;
        margin: 0 auto;
        padding-bottom: 132px;
        > .headline {
          font-size: 28px;
          font-weight: 600;
          color: #444a62;
          line-height: 40px;
          position: relative;
          padding-top: 62px;
          text-align: center;
        }
        // > .headline::after {
        //   position: absolute;
        //   bottom: -13px;
        //   left: 50%;
        //   margin-left: -14px;
        //   content: "";
        //   background: #ef623d;
        //   box-shadow: 0px 0px 10px -2px rgba(133, 133, 133, 0.66);
        //   border-radius: 2px;
        //   opacity: 0.59;
        //   width: 28px;
        //   height: 5px;
        // }
        .introduce {
          display: flex;
          align-items: center;
          margin-top: 73px;
          > img {
            width: 526px;
            height: 405px;
            margin-left: -14px;
          }
          .right {
            padding-left: 50px;
            flex: 1;
            display: flex;
            justify-content: center;
            flex-direction: column;
            .title {
              font-size: 32px;
              font-weight: 600;
              color: #000000;
              line-height: 45px;
              padding-left: 6px;
            }
            .desc {
              font-size: 16px;
              font-weight: 400;
              color: #000000;
              line-height: 38px;
              margin-top: 22px;
              text-align: justify;
            }
          }
        }
        .character {
          display: flex;
          justify-content: space-between;
          margin-top: 100px;
          .left {
            flex: 1;
            .headline {
              font-size: 32px;
              font-weight: 600;
              color: #000000;
              line-height: 45px;
            }
            .list {
              margin-top: 22px;
              .title {
                font-size: 16px;
                font-weight: 500;
                color: #f27529;
                line-height: 22px;
                text-align: justify;
                font-family: pingFangSC-Medium;
              }
              .desc {
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                line-height: 20px;
                margin-top: 12px;
                text-align: justify;
              }
            }
          }
          .right {
            width: 710px;
            margin-top: 94px;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    .module:nth-child(2n) {
      // background-image: url(https://growlib-glp-public.oss-cn-beijing.aliyuncs.com/images/www/2.1/backgroundImg/kehu_fanwei.6);
      background-size: 100% 100%;
    }
    .gly > div .character .right {
      margin-top: 93px;
      width: 716px;
    }
    .Metaverse{
      height: 618px;
      background: url(./assets/bj_bg.png);
      > div .character .left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 120px;
        .title{
          display: flex;
          align-items: center;
          font-weight: bold;
          img{
            margin-right: 15px;
            width: 25px;
          }
        }
        .desc{
          margin-top: 5px !important;
          margin-left: 40px;
        }
      }
      > div .character .right {
        margin-top: 25px;
        width: 450px;
        margin-right: 65px;
      }
    }
    .scenario > div .character .right {
      margin-top: 0px;
      width: 510px;
    }
    .scenario > div .character .left {
      width: 690px;
    }
    .k12 {
      background: url(https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/b85d0b101ec395f26617d40b997efa6a.png);
      .content {
        width: 1200px;
        margin: 0 auto;
        padding-top: 54px;
        > div {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .three {
          margin-bottom: 30px;
          .list {
            width: 380px;
            height: 420px;
            background: #fff;
            border-radius: 19px;
            overflow: hidden;
            > img {
              width: 100%;
              height: 324px;
              display: block;
              object-fit: cover;
            }
            .title {
              display: block;
              line-height: 96px;
              text-align: center;
              font-size: 22px;
              font-weight: 400;
              color: #000000;
            }
          }
        }
        .two {
          .list {
            width: 585px;
            height: 420px;
            background: #fff;
            border-radius: 19px;
            overflow: hidden;
            > img {
              width: 100%;
              height: 324px;
              display: block;
              object-fit: cover;
            }
            .title {
              display: block;
              line-height: 96px;
              text-align: center;
              font-size: 22px;
              font-weight: 400;
              color: #000000;
            }
          }
        }
      }
    }
    .earnings{
      height: 738px;
      background: url(./assets/bj_bg.png);
      .headline{
        margin-bottom: 30px;
      }
      img{
        // width: 1200px;
        margin: 0 auto;
      }
    }
    .proEdvantage{
      .advantage{
        // margin-top: 30px;
        >div{
          margin-top: 30px;
          .head{
            margin-bottom: 30px;
            display: flex;
            align-items: center;
            height: 25px;
            .icon{
              width: 30px;
              height: 30px;
              margin-right: 20px;
            }
            >span{
              display: inline-block;
              height: 25px;
              line-height: 25px;
              font-weight: bold;
              font-size: 18px;
            }
          }
          .desc{
            padding: 20px 50px 0 50px;
            margin-left: 45px;
            background-color: #F7FAFC;
            >span{
              font-size: 16px;
            }
            >span:nth-child(1) {
              font-weight: bold;
            }
          }
          .desc:last-child{
            padding-bottom: 20px;
          }
        }
      }
    }
    .support_five{
      .content {
        width: 1200px;
        margin: 0 auto;
        padding-top: 54px;
        display: flex;
        flex-wrap: wrap;
        .left, .right{
          width: 262.5px;
          height: 100%;
          padding: 115px 0 78px 0;
          .list{
            margin-bottom: 122.7px;
          }
          .list:last-child{
            margin-bottom: 0;
          }
          .title{
            width: 232.4px;
            height: 58.3px;
            font-size: 18px;
            font-weight: 550;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 0 20px 40px;
            background: url(./assets/five_in_one_left.png);
            background-size: 100% 100%;
          }
          .desc{
            line-height: 24px;
            font-size: 16px;
          }
        }
        .right{
          padding-bottom: 28px;
          .list{
            margin-bottom: 145px;
            .title{
              margin: 0;
              margin-bottom: 20px;
              background: url(./assets/five_in_one_right.png);
              background-size: 100% 100%;
            }
          }
          .list:last-child{
            margin-top: 10px;
          }
        }
        img{
          width: 575px;
          margin: 0 50px;
        }
        .bottom{
          width: 100%;
          padding: 20px 487px 0;
          .list{
            margin: 0 auto;
            .title{
              width: 232.4px;
              height: 58.3px;
              font-size: 18px;
              font-weight: 550;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-bottom: 20px;
              background: url(./assets/five_in_one_bottom.png);
              background-size: 100% 100%;
            }
            .desc{
              line-height: 24px;
              font-size: 16px;
            }
          }
        }
      }
    }
    .support_one{
      height: 600px;
      background: url(./assets/bj_chicheng.png);
      > div .character .left .desc {
        display: flex;
        >div{
          width: 350px;
          display: flex;
          flex-direction: column;
          span{
            display: inline-block;
            padding: 20px 0 0;
            font-size: 18px;
          }
        }
      }
      > div .character .right{
        margin-top: -40px;
        img{
          margin-top: 0;
        }
      }
    }
    .policy{
      > div .character{
        display: flex;
        justify-content: space-between;
        margin-top: 0;
        >div{
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          span{
            width: 240px;
            display: inline-block;
            padding: 30px 50px;
            font-size: 18px;
            text-align: center;
            background-color: #F7FAFC;
            margin-bottom: 30px;
          }
        }
        >div{
          img{
            // width: 300px
          }
        }
      }
    }
    .condition{
      background: url(./assets/bj_tiaojian@2x.png);
      > div .character{
        display: flex;
        justify-content: space-between;
        >div{
          display: flex;
          flex-direction: column;
          align-items: center;
          img{
            width: 60px;
            height: 60px;
            margin-bottom: 20px;
          }
          span{
            font-size: 18px;
            font-weight: bold;
          }
        }
      }
    }
    .process{
      >div .character{
        width: 100%;
        height: 400px;
        position: relative;
        .line{
          width: 100%;
          height: 20px;
          // z-index: 9;
          background: url(https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/052ceeda760b5b06b874ef0df00e7577.png) center;
          background-size: 100% 100%;
        }
        .content{
          width: calc(100% - 90px);
          top: 2px;
          left: 10px;
          position: absolute;
          display: flex;
          justify-content: space-between;
          >div{
            display: flex;
            flex-direction: column;
            align-items: center;
            // justify-content: center;
            .round{
              width: 15px;
              height: 15px;
              border-radius: 50%;
              background-size: 100% 100%;
              margin-left: -2px;
              background: url(https://growlib-glp-u-resources.oss-cn-beijing.aliyuncs.com/res/123/0e2699c61fa7e0309152f838c5c6f5a6.png) center;
            }
            .short_line{
              height: 100px;
              width: 5px;
              border-left: 3px dotted #c7cbd1;
            }
            span{
              display: inline-block;
              text-align: center;
              font-size: 16px;
              font-weight: 550;
              padding: 30px 15px;
              Letter-spacing: 6px;
              writing-mode: vertical-rl;
              background: linear-gradient(#ECEDF1, #F3F6F9);
            }
          }
        }
      }
    }
    // 修改tab分页标签组件样式
    /deep/.el-tabs__item {
      width: 150px;
      padding: 0;
      color: #6b738c;
      text-align: center;
      border-radius: 20px;
    }
    /deep/.el-tabs__nav {
      border-radius: 20px;
      background-color: #efefef;
    }
    /deep/.el-tabs__item:hover {
      color: #6b738c;
    }
    /deep/.el-tabs__item.is-active,
    /deep/.el-tabs__item.is-active:hover {
      color: #fff;
      background: #f27529 !important;
    }
    /deep/.el-tabs__active-bar,
    /deep/.el-tabs__nav-wrap::after {
      height: 0;
    }
    // 修改页面分页组件样式
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
      color: #fff;
      border: 0;
      background: #f27529 !important;
    }
  }
}
</style>
